import React, { useState } from "react";
import Display from "./Display";
import Buttons from "./Buttons";
import "../../assets/css/calculator.css";
import { evaluate, round } from "mathjs";
import Draggable from "react-draggable";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { toast } from "react-toastify";

function Calculator({close}) {
  const [input, setInput] = useState("");
  const [answer, setAnswer] = useState("");
  const [memory, setMemory] = useState(0);

  //input
  const inputHandler = (event) => {
    if (answer === "Invalid Input!!") return;
    let val = event.target.innerText;

    if (val === "x2") val = "^2";
    else if (val === "x3") val = "^3";
    else if (val === "3√") val = "^(1÷3)";
    else if (val === "log") val = "log(";

    let str = input + val;
    if (str.length > 14) return;

    if (answer !== "") {
      setInput(answer + val);
      setAnswer("");
    } else setInput(str);
    // setInput(str);
  };

  // Clear all (C)
  const clearAll = () => {
    setInput("");
    setAnswer("");
  };

  // Clear entry (CE): remove last number token
  const clearEntry = () => {
    if (answer !== "") {
      setAnswer("");
      return;
    }
    const removed = (input || "").replace(/([0-9]*\.?[0-9]*)$/,'');
    setInput(removed);
  };

  // Transfer Display: put value into the first text box on page (or copy as fallback)
  const copyInput = () => {
    const text = String(answer || input || "0");

    // Prefer writing into the first editable text field inside exam body
    const root = document.getElementById('exam_body') || document;
    const candidate = root.querySelector(
      'input[type="text"]:not([disabled]):not([readonly]), input[type="number"]:not([disabled]):not([readonly]), textarea:not([disabled]):not([readonly])'
    );

    // Helper: assign value using native setter so React controlled inputs receive it
    const setNativeValue = (el, value) => {
      const tag = el && el.tagName;
      if (tag === 'INPUT') {
        const proto = el.type === 'number' ? HTMLInputElement.prototype : HTMLInputElement.prototype;
        const desc = Object.getOwnPropertyDescriptor(proto, 'value');
        desc && desc.set ? desc.set.call(el, value) : (el.value = value);
      } else if (tag === 'TEXTAREA') {
        const desc = Object.getOwnPropertyDescriptor(HTMLTextAreaElement.prototype, 'value');
        desc && desc.set ? desc.set.call(el, value) : (el.value = value);
      } else {
        el.value = value;
      }
    };

    if (candidate && (candidate instanceof HTMLInputElement || candidate instanceof HTMLTextAreaElement)) {
      try {
        // Replace value via native setter and dispatch events so React picks it up
        setNativeValue(candidate, text);
        candidate.dispatchEvent(new Event('input', { bubbles: true }));
        candidate.dispatchEvent(new Event('change', { bubbles: true }));
        candidate.blur();
        candidate.focus();
        toast.success("انتقال و ثبت مقدار: " + text);
        return;
      } catch {
        // fall back to clipboard
      }
    }

    // Fallback: copy to clipboard if field not found
    try {
      navigator.clipboard.writeText(text);
      toast.success("کپی در کلیپ‌بورد: " + text);
    } catch {
      toast.error("انتقال/کپی مقدار انجام نشد");
    }
  }

  // check brackets are balanced or not
  const checkBracketBalanced = (expr) => {
    let stack = [];
    for (let i = 0; i < expr.length; i++) {
      let x = expr[i];
      if (x === "(") {
        stack.push(x);
        continue;
      }

      if (x === ")") {
        if (stack.length === 0) return false;
        else stack.pop();
      }
    }
    return stack.length === 0;
  };

  // calculate final answer
  const calculateAns = () => {
    if (input === "" && answer !== "") return; // nothing new
    if (input === "") return;
    let result = 0;
    let finalexpression = input;
    //  finalexpression = input.replaceAll("^", "**");  //for eval()
    finalexpression = finalexpression.replaceAll("x", "*");
    finalexpression = finalexpression.replaceAll("÷", "/");

    // evaluate square root
    let noSqrt = input.match(/√[0-9]+/gi);

    if (noSqrt !== null) {
      let evalSqrt = input;
      for (let i = 0; i < noSqrt.length; i++) {
        evalSqrt = evalSqrt.replace(
          noSqrt[i],
          `sqrt(${noSqrt[i].substring(1)})`
        );
      }
      finalexpression = evalSqrt;
    }

    try {
      // check brackets are balanced or not
      if (!checkBracketBalanced(finalexpression)) {
        const errorMessage = { message: "Brackets are not balanced!" };
        throw errorMessage;
      }
      result = evaluate(finalexpression); //mathjs
    } catch (error) {
      result =
        error.message === "Brackets are not balanced!"
          ? "Brackets are not balanced!"
          : "Invalid Input!!"; //error.message;
    }
    isNaN(result) ? setAnswer(result) : setAnswer(round(result, 3));
  };

  // remove last character
  const backspace = () => {
    if (answer !== "") {
      setInput(answer.toString().slice(0, -1));
      setAnswer("");
    } else setInput((prev) => prev.slice(0, -1));
  };

  // change prefix of expression
  const changePlusMinus = () => {
    //need to change for answer
    if (answer === "Invalid Input!!") return;
    else if (answer !== "") {
      let ans = answer.toString();
      if (ans.charAt(0) === "-") {
        let plus = "+";
        setInput(plus.concat(ans.slice(1, ans.length)));
      } else if (ans.charAt(0) === "+") {
        let minus = "-";
        setInput(minus.concat(ans.slice(1, ans.length)));
      } else {
        let minus = "-";
        setInput(minus.concat(ans));
      }
      setAnswer("");
    } else {
      if (input.charAt(0) === "-") {
        let plus = "+";
        setInput((prev) => plus.concat(prev.slice(1, prev.length)));
      } else if (input.charAt(0) === "+") {
        let minus = "-";
        setInput((prev) => minus.concat(prev.slice(1, prev.length)));
      } else {
        let minus = "-";
        setInput((prev) => minus.concat(prev));
      }
    }
  };

  // Memory handlers
  const memoryRecall = () => {
    const val = String(memory);
    if (answer !== "") {
      setInput(val);
      setAnswer("");
    } else {
      setInput((prev) => prev + val);
    }
  };

  const memoryClear = () => setMemory(0);
  const memoryAdd = () => {
    let currentVal = 0;
    if (answer !== "") currentVal = Number(answer);
    else if (input !== "") {
      let expr = input.replaceAll("x", "*").replaceAll("÷", "/");
      const noSqrt = expr.match(/√[0-9]+/gi);
      if (noSqrt) {
        for (let i = 0; i < noSqrt.length; i++) {
          expr = expr.replace(noSqrt[i], `sqrt(${noSqrt[i].substring(1)})`);
        }
      }
      try { currentVal = Number(evaluate(expr)); } catch { currentVal = 0; }
    }
    if (!isNaN(currentVal)) setMemory((m) => m + currentVal);
  };

  return (
    <>
      <div dir="ltr" id="calculator">
        <Draggable>
          <div className="main">
            <div className="calc-header">
              <button type="button" className="closeClac" onClick={() => close(false)}>
                <FontAwesomeIcon icon="xmark" />
              </button>
            </div>
            <Display input={input} setInput={setInput} answer={answer} />
            <Buttons
              inputHandler={inputHandler}
              clearAll={clearAll}
              clearEntry={clearEntry}
              changePlusMinus={changePlusMinus}
              calculateAns={calculateAns}
              memoryAdd={memoryAdd}
              memoryRecall={memoryRecall}
              memoryClear={memoryClear}
              transferDisplay={copyInput}
              backspace={backspace}
              answer={answer}
            />
          </div>
        </Draggable>
      </div>
    </>
  );
}

export default Calculator;
